import { render, staticRenderFns } from "./AddSelectStudent.vue?vue&type=template&id=1eb396ed&"
import script from "./AddSelectStudent.vue?vue&type=script&lang=js&"
export * from "./AddSelectStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports